module.exports = __webpack_public_path__ + "img/financial-times-screener-dark.6084f671.png";